module.exports = __webpack_public_path__ + "assets/ec89a76213d2e2752ed664b2059e1954.png";